import abstractModel from "../../core/ShopModel";

const resource = 'retailers/subcategories';

const model = abstractModel(resource);

const nestedPath = (categoryWebId) => (
  `retailers/categories/${categoryWebId}/subcategories`
);

const create = async (categoryWebId, params) => (
  model.post(params, { path: nestedPath(categoryWebId) })
);

const update = async (categoryWebId, subcategoryWebId, params) => (
  model.save({ ...params, id: subcategoryWebId }, { path: nestedPath(categoryWebId) })
);

const remove = async (categoryWebId, subcategoryWebId) => (
  model.remove({ id: subcategoryWebId }, { path: nestedPath(categoryWebId) })
);

export default {
  ...model,
  create,
  update,
  remove
};
